export default angular.module('syVideoAnalytics', ['syAnalytics'])
    /**
     * @ngdoc service
     * @name syVideoAnalytics.service:VideoAnalyticsService
     * @description
     * Track video interaction with the website using Google Tag Manager
     */
    // @ngInject
    .service('VideoAnalyticsService', function ($window, AnalyticsService) {
        var youtubePlayers = {};
        var percentageInterval;
        var trackedPercentage = 0;
        // Return the title of a video
        // @param player {object} YouTube player object
        function getVideoTitle(player) {
            return player.getVideoData().title;
        }
        // Return the current state of the player during an event
        // @param event {object} The YT event containing the current state
        function getPlayerAction(event) {
            switch (event.data) {
            case YT.PlayerState.PLAYING:
                percentageInterval = setInterval(function () {
                    trackPercentage(event.target);
                }, 2000);
                return 'play';
            case YT.PlayerState.PAUSED:
                clearInterval(percentageInterval);
                return 'pause';
            case YT.PlayerState.BUFFERING:
                clearInterval(percentageInterval);
                return 'buffering';
            case YT.PlayerState.ENDED:
                clearInterval(percentageInterval);
                return 'completed';
            }
            return null;
        }
        // Track percentage viewed in percentages of 25%
        // @param player {object} YouTube player object
        function trackPercentage(player) {
            var currentPercentage = player.getCurrentTime() / player.getDuration();
            if (currentPercentage > (trackedPercentage + 0.25)) {
                var videoTitle = getVideoTitle(player);
                trackedPercentage += 0.25;
                AnalyticsService.trackEvent('video', (trackedPercentage * 100) + '%', videoTitle);
            }
        }
        // Listen for play/pause events
        // @params event {object} YouTube API event object
        function onPlayerStateChange(event) {
            var playerAction = getPlayerAction(event);
            var videoTitle = getVideoTitle(event.target);
            if (playerAction) {
                AnalyticsService.trackEvent('video', playerAction, videoTitle);
            }
        }
        // Listen for player to be loaded and ready
        // @param event {object} YouTube API event object
        function onPlayerReady(event) {
            var videoTitle = getVideoTitle(event.target);
            AnalyticsService.trackEvent('video', 'view', videoTitle);
        }
        // Add YouTube API callbacks to the global scope and then load the API
        function loadYouTubeAPI(callback) {
            // Callback is called when YouTube API is ready for the provided video
            $window.onYouTubeIframeAPIReady = callback;
            // Load the Youtube JS API
            var firstScript = document.getElementsByTagName('script')[0];
            var apiScript = document.createElement('script');
            apiScript.src = '//www.youtube.com/iframe_api';
            apiScript.async = true;
            apiScript.id = 'ytapi';
            firstScript.parentNode.insertBefore(apiScript, firstScript);
        }
        // Instantiate a new player object for an embedded video iframe
        // @param iframe {object} IFRAME DOM element
        this.registerPlayer = function registerPlayer($iframe) {
            function bindYouTubeEvents() {
                var iframeSrc = $iframe.attr('src');
                if (!youtubePlayers[iframeSrc]) {
                    youtubePlayers[iframeSrc] = new YT.Player($iframe[0], {
                        events: {
                            onReady: onPlayerReady,
                            onStateChange: onPlayerStateChange
                        }
                    });
                }
            }
            // If the API has not been loaded, load the API before
            // binding player events
            if (typeof YT === 'undefined') {
                return loadYouTubeAPI(bindYouTubeEvents);
            }
            return bindYouTubeEvents();
        };
    });
